// Shared type + colour tokens for the case history card.
//
// Neutral greys carry the whole surface; Thrive magenta is reserved for links
// (Edit / Regenerate / Touch history) and the selected menu item, amber for the
// staleness chip. Dates, eyebrows and group headers are monospace.

export const MONO =
  'ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace';

/** Row titles. */
export const INK = "#111827";
/** Summary + note body text. */
export const INK_2 = "#374151";
/** Second lines, dates, group headers. */
export const MUTED = "#6b7280";
/** Eyebrows, folded/system one-liners, chevrons. */
export const FAINT = "#9ca3af";
/** Hairlines and card borders. */
export const RULE = "#e5e7eb";
/** Summary panel fill. */
export const PANEL_BG = "#f6f7f8";
/** Expanded note block fill. */
export const QUOTE_BG = "#f8fafc";
/** Expanded note block left rail + row glyphs. */
export const SLATE = "#94a3b8";
/** Links and the selected menu item. */
export const ACCENT = "#9E1F63";

export const AMBER_BG = "#fdf3e2";
export const AMBER_INK = "#a15a00";
export const AMBER_RULE = "#e8d3ae";

/** Due-date closeness colours for the Upcoming & Overdue rows. */
export const DUE_OVERDUE = "#dc2626";
export const DUE_TODAY = "#ea580c";
export const DUE_SOON = "#d97706";
export const DUE_LATER = "#16a34a";
